import {
  getAllProductsByStyle,
  getProductTags,
  setAttributes,
  findGetParameter,
} from '../helpers/productStyles';
import Swiper from 'swiper/bundle';

import { validateEmail } from '../helpers/util';

export default class ProductVariants {
  constructor(productEl) {
    this.el = productEl;
    this.dataEl = this.el.querySelector('[data-product-data]');
    this.data = JSON.parse(this.dataEl.innerHTML);
    this.swatchesType = this.el.querySelector(
      '[data-swatches-type]',
    )?.dataset?.swatchesType;
    this.init();
  }

  init = async () => {
    if (!this.el) return;
    const styleTag = getProductTags(this.data, 'style');
    if (styleTag.length) {
      this.allProductStyles = await getAllProductsByStyle(styleTag);
      this.allProductStyles.products = this.sortByCustomOrder(
        this.allProductStyles.products,
      );
      this.colorCategories = this.getColorCategories(
        this.allProductStyles.products,
      );
    } else {
      this.allProductStyles = false;
    }
    this.badgeTags = getProductTags(this.data, 'badge');
    this.benefitTags = getProductTags(this.data, 'benefits');
  };

  getColorCategories = (products) => {
    let colorCategories = [];
    products.map((product) => {
      if (product.colorCategory) {
        if (colorCategories.indexOf(product.colorCategory) === -1) {
          colorCategories.push(product.colorCategory.toLowerCase());
        }
      }
    });
    const fromIndex = colorCategories.indexOf('color');
    const toIndex = colorCategories.length - 1;
    const uncategorisedElement = colorCategories.splice(fromIndex, 1)[0];
    colorCategories.splice(toIndex, 0, uncategorisedElement);
    return colorCategories;
  };

  sortByCategories = (products, colorOrder) => {
    let finalVariantOrder = [];
    colorOrder.forEach((color) => {
      if (color == 'color') return;
      let sortedProducts = products.filter((product) => {
        return product.colorCategory == color;
      });
      finalVariantOrder = finalVariantOrder.concat(sortedProducts);
    });
    let unSorted = products.filter(function (obj) {
      return finalVariantOrder.indexOf(obj) == -1;
    });
    // return finalVariantOrder.concat(unSorted);
    return finalVariantOrder;
  };

  sortByCustomOrder = (products) => {
    let customVariantOrder = [];
    let interimOrder = [];
    let finalVariantOrder = [];

    // Sort variants by best sellers first, then by time
    let firstOrder = products.sort(
      (a, b) =>
        b.isBestSeller.length - a.isBestSeller.length ||
        a.createdAt.localeCompare(b.createdAt),
    );

    // If a custom order exists, sort by that
    if (this.data.variantDisplayOrder.length > 0) {
      customVariantOrder = this.data.variantDisplayOrder
        .replace('and ', ',')
        .replace(/\s/g, '');
      customVariantOrder = customVariantOrder.split(',');
      firstOrder.sort(function (a, b) {
        return (
          customVariantOrder.indexOf(a.handle) -
          customVariantOrder.indexOf(b.handle)
        );
      });
      firstOrder.forEach((item, index) => {
        if (customVariantOrder.indexOf(item.handle) >= 0) {
          finalVariantOrder.push(item);
        } else {
          interimOrder.push(item);
        }
      });
      interimOrder.sort(
        (a, b) =>
          b.isBestSeller.length - a.isBestSeller.length ||
          a.createdAt.localeCompare(b.createdAt),
      );
      interimOrder.forEach((item, index) => {
        finalVariantOrder.push(interimOrder[index]);
      });
      return finalVariantOrder;
    } else {
      return firstOrder;
    }
  };

  buildBadge = (tags = []) => {
    const badgesInfo = JSON.parse(
      document.querySelector('[data-badge-data]').innerHTML,
    );
    let badgeReturn;
    if (tags != []) {
      tags.forEach((tag) => {
        let singleBadgeInfo = badgesInfo.badges.filter(function (badge) {
          return badge.badgeTag == tag;
        })[0];
        if (singleBadgeInfo != undefined) {
          let singleBadgeWrap = document.createElement('div');
          singleBadgeWrap.classList.add(
            'badge__single',
            singleBadgeInfo.badgePosition,
          );
          singleBadgeWrap.style.backgroundColor = singleBadgeInfo.badgeColor;
          if (singleBadgeInfo.badgeText != '') {
            let singleBadgeText = document.createElement('span');
            singleBadgeText.style.color = singleBadgeInfo.badgeTextColor;
            if (singleBadgeInfo.badgeTextLine != '1') {
              singleBadgeInfo.badgeText = singleBadgeInfo.badgeText.replace(
                ' ',
                '<br/>',
              );
              singleBadgeWrap.classList.add('badge__single--lines');
            }
            singleBadgeText.innerHTML = singleBadgeInfo.badgeText;
            singleBadgeWrap.appendChild(singleBadgeText);
          }
          if (!badgeReturn) {
            badgeReturn = singleBadgeWrap;
          }
        }
      });
      return badgeReturn;
    }
  };

  buildBenefits = (tags = [], type) => {
    const benefitsStack = document.querySelectorAll('[data-benefits-data]');
    if (tags != []) {
      let benefitsReturn = [];
      benefitsStack.forEach((benefitSingle) => {
        let benefitsInfo = JSON.parse(benefitSingle.innerHTML);
        tags.forEach((tag) => {
          let singleBenefitInfo = benefitsInfo.benefits.filter(function (
            benefit,
          ) {
            return benefit.benefitId == tag;
          })[0];
          if (singleBenefitInfo != undefined) {
            let singleBenefitWrap = document.createElement('figure');
            singleBenefitWrap.classList.add(`${type}__benefits--item`);
            if (singleBenefitInfo.benefitImage != null) {
              let singleBenefitImageWrap = document.createElement('span');
              singleBenefitImageWrap.classList.add(`${type}__benefits--ico`);
              let singleBenefitImage = document.createElement('img');
              setAttributes(singleBenefitImage, {
                src: singleBenefitInfo.benefitImage,
                alt: '',
                srcset: this.buildSrcSet(singleBenefitInfo.benefitImage),
              });
              singleBenefitImageWrap.prepend(singleBenefitImage);
              singleBenefitWrap.prepend(singleBenefitImageWrap);
            }
            if (singleBenefitInfo.benefitTitle != '') {
              let singleBenefitText = document.createElement('figcaption');
              singleBenefitText.innerHTML = singleBenefitInfo.benefitTitle;
              singleBenefitWrap.appendChild(singleBenefitText);
            }
            benefitsReturn.push(singleBenefitWrap);
          }
        });
      });
      return benefitsReturn;
    }
  };

  buildMoreItem = function (product) {
    let aDesktop = document.createElement('a');
    let aMobile = document.createElement('a');
    let desktopMaxSwatches = 7; // max
    let mobileMaxSwatches = 3;

    product.div.classList.add(
      'product-card__swatches--item',
      'product-card__swatches--more',
    );

    aDesktop.classList.add('swatches-count-desktop');
    setAttributes(aDesktop, {
      href: product.url,
      'data-product-link': '',
    });

    if (product.moreItem - desktopMaxSwatches > 0) {
      aDesktop.textContent = '+' + (product.moreItem - 7);
    }

    aMobile.classList.add('swatches-count-mobile');
    setAttributes(aMobile, {
      href: product.url,
      'data-product-link': '',
    });

    if (product.moreItem - mobileMaxSwatches > 0) {
      aMobile.textContent = '+' + (product.moreItem - 3);
    }

    product.div.appendChild(aDesktop);
    product.div.appendChild(aMobile);
    return product.div;
  };

  buildSwatchItem = (product = {}, moreItem = 0) => {
    product.div = document.createElement('div');
    product.moreItem = moreItem;
    if (moreItem != 0) {
      return this.buildMoreItem(product);
    }
    setAttributes(product.div, {
      'data-product-id': product?.id,
      'data-product-swatch': '',
      'data-color-name': product.selectedColor,
      'data-product-category': product.colorCategory.toLowerCase(),
      'data-product-selected-variant':
        product?.selectedOrFirstAvailableVariant.id,
    });
    if (
      product.available ||
      product.tags.includes('flag:enable-back-in-stock')
    ) {
      // !product?.available ? product.div.classList.add("disabled") : null;
      if (
        this.el.classList.contains('product-card') ||
        this.swatchesType == 'color'
      ) {
        let span = document.createElement('span');
        product.div.classList.add('product-card__swatches--item');
        span.classList.add('swatch-color');
        if (product.swatchHexcode1 != null && product.swatchHexcode1 != '') {
          span.style.backgroundColor = product.swatchHexcode1;
        } else {
          span.style.backgroundColor = '#ffffff';
        }
        if (product.swatchHexcode2 != null && product.swatchHexcode2 != '') {
          let spanAlternative = document.createElement('span');
          spanAlternative.classList.add('swatch-color--alternative');
          spanAlternative.style.backgroundColor = product.swatchHexcode2;
          product.div.appendChild(spanAlternative);
        }
        if (product.swatchImgUrl != null && product.swatchImgUrl != '') {
          span.classList.add('swatch-color--image');
          let image = document.createElement('img');
          setAttributes(image, {
            src: product.swatchImgUrl,
            alt: '',
            srcset: this.buildSrcSet(product.swatchImgUrl),
          });
          span.appendChild(image);
        }
        product.div.appendChild(span);
      } else {
        let imageWrap = document.createElement('div');
        let videos = '';
        let imagesWithIndex = '';
        product.div.classList.add('variants__color--item');
        product.media.forEach((media) => {
          if (imagesWithIndex == '') {
            imagesWithIndex += `${media.src}*${media.position}`;
          } else {
            imagesWithIndex += `,${media.src}*${media.position}`;
          }
          if (media.media_type != 'image') {
            let videoItem = '';
            if (media.media_type == 'video') {
              videoItem = `${media.sources[0].url}~video`;
            } else {
              videoItem = `${media.external_id}~${media.host}`;
            }
            if (videos == '') {
              videos += videoItem;
            } else {
              videos += `|${videoItem}`;
            }
          }
        });
        setAttributes(product.div, {
          'data-product-selected-variant':
            product?.selectedOrFirstAvailableVariant.id,
        });
        imageWrap.classList.add('variants__color--item__image-wrap');
        if (product?.imageThumb != null && product?.imageThumb != '') {
          let thumbChoice = '';
          const images = product?.media;
          images.every((image) => {
            if (image.src != null) {
              if (image?.src.toLowerCase().includes('main')) {
                thumbChoice = image.src;
                return false;
              }
            }
            return true;
          });
          if (thumbChoice == '') {
            thumbChoice = product?.featuredImage;
          }
          imageWrap.classList.add('swatch-color--image');
          let image = document.createElement('img');
          setAttributes(image, {
            src: product?.imageThumb2x,
            alt: '',
            srcset: `${product?.imageThumb1x} 1x, ${product?.imageThumb2x} 2x, ${product?.imageThumb3x} 3x`,
          });
          imageWrap.appendChild(image);
        }
        product.div.appendChild(imageWrap);
      }
      return product.div;
    } else {
      return false;
    }
  };

  updatePrice = (variant) => {
    this.el.querySelectorAll('[data-product-price]').forEach((priceItem) => {
      priceItem.textContent = variant.formattedPrice;
      if (
        !variant.formattedCompareAtPrice ||
        variant.formattedCompareAtPrice == variant.formattedPrice
      ) {
        priceItem.classList.remove('sale-price');
      } else if (variant.formattedCompareAtPrice != variant.formattedPrice) {
        priceItem.classList.add('sale-price');
      }
    });
  };

  updateCompareAtPrice = (variant) => {
    let comparePrice = variant.formattedCompareAtPrice
      ? variant.formattedCompareAtPrice
      : '';
    if (variant.formattedCompareAtPrice != variant.formattedPrice) {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = comparePrice;
        });
    } else {
      this.el
        .querySelectorAll('[data-product-compare]')
        .forEach((priceItem) => {
          priceItem.textContent = '';
        });
    }
  };

  updateKlarna = (variant) => {
    const klarnaEls = document.getElementsByTagName('klarna-placement');
    if (!variant && !klarnaEls) return;
    if (klarnaEls.length) {
      klarnaEls.forEach((el) => {
        el.setAttribute('data-purchase-amount', variant.price);
      });
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    }
  };

  buildOtherSwatches = (product = {}, type = '', container = '') => {
    product.optionsWithValues.forEach((option) => {
      let optionLower = option.name.toLowerCase();
      let sizeListNode;
      if (optionLower != 'color') {
        if (container) {
          sizeListNode = container;
        } else {
          sizeListNode = document.querySelector(
            `[data-option-name='${optionLower}'] .variants__size--list`,
          );
        }
        if (sizeListNode) {
          sizeListNode.innerHTML = '';
          let sizeContainerNode = sizeListNode.parentNode;
          let backInStockForm = this.el.querySelectorAll(
            `.${type}__back-in-stock`,
          );
          let backInStockFormButton = this.el.querySelectorAll(
            `.${type}__back-in-stock-form-button`,
          );
          let formWrapButtons = this.el.querySelectorAll(
            `.${type}__form--wrap button[data-product-add]`,
          );
          sizeContainerNode.style.display = 'none';
          let isFirstValue = true;
          let displayedOptions = [];
          let fireViewedOOS = false;
          option.values.forEach((value, index) => {
            let otherSwatch = document.createElement('div');
            otherSwatch.classList.add('variants__size--item');
            if (type != 'main-product' || product.type == 'Gift Cards') {
              if (
                isFirstValue &&
                product.selectedOrFirstAvailableVariant.options.includes(value)
              ) {
                otherSwatch.classList.add('selected');
                isFirstValue = false;
                let comparePriceAttribute = product
                  .selectedOrFirstAvailableVariant.compare_at_price
                  ? product.selectedOrFirstAvailableVariant.compare_at_price
                  : '';
                formWrapButtons.forEach((formWrapButton) => {
                  setAttributes(formWrapButton, {
                    'data-compare-price-item': comparePriceAttribute,
                    'data-price-item':
                      product.selectedOrFirstAvailableVariant.price,
                  });
                });
              }
            } else {
              if (findGetParameter('variant')) {
                let choosedVariant = product.variants.filter((variant) => {
                  return variant.id == findGetParameter('variant');
                });
                if (choosedVariant[0].options.includes(value)) {
                  otherSwatch.classList.add('selected');
                  if (choosedVariant[0].available == false) {
                  } else {
                    if (
                      product.size_guide_cta_enabled &&
                      document.querySelector(`.size-guide-table`)
                    ) {
                      if (
                        document.querySelector(
                          `.size-guide-table .add-size[data-variant-option-value="${choosedVariant[0].options[1]}"]`,
                        )
                      ) {
                        document
                          .querySelector(
                            `.size-guide-table .add-size[data-variant-option-value="${choosedVariant[0].options[1]}"]`,
                          )
                          .parentNode.classList.add('selected');
                      }
                    }
                    this.el.querySelector(
                      '.variants__size--label p span',
                    ).style.display = 'none';
                    formWrapButtons.forEach((formWrapButton) => {
                      formWrapButton.textContent = 'Add to Cart';
                      let comparePriceAttribute = choosedVariant[0]
                        .compareAtPrice
                        ? choosedVariant[0].compareAtPrice
                        : '';
                      setAttributes(formWrapButton, {
                        'data-selected-variant': choosedVariant[0].id,
                        'data-drawer-trigger': '',
                        'data-compare-price-item': comparePriceAttribute,
                        'data-price-item': choosedVariant[0].price,
                      });
                    });
                  }
                }
              } else if (product.variants.length == 1) {
                if (product.selectedOrFirstAvailableVariant.available) {
                  otherSwatch.classList.add('selected');
                  this.el.querySelector(
                    '.variants__size--label p span',
                  ).style.display = 'none';
                  formWrapButtons.forEach((formWrapButton) => {
                    formWrapButton.textContent = 'Add to Cart';
                    let comparePriceAttribute = product
                      .selectedOrFirstAvailableVariant.compareAtPrice
                      ? product.selectedOrFirstAvailableVariant.compareAtPrice
                      : '';
                    setAttributes(formWrapButton, {
                      'data-selected-variant':
                        product.selectedOrFirstAvailableVariant.id,
                      'data-drawer-trigger': '',
                      'data-compare-price-item': comparePriceAttribute,
                      'data-price-item':
                        product.selectedOrFirstAvailableVariant.price,
                    });
                  });
                }
                sizeContainerNode.style.display = 'block';
              }
            }
            setAttributes(otherSwatch, {
              'data-variant-option-value': value,
              'data-variant-option-index': `option${option.position}`,
              'data-variant-available': product.variants[index].available,
            });

            let [choosedVariant] = product.variants.filter((variant) => {
              return variant.id == findGetParameter('variant');
            });

            if (!fireViewedOOS && choosedVariant && !choosedVariant.available) {
              fireViewedOOS = true;
              let itemTrack = {
                Name: product.title,
                ProductID: choosedVariant.id,
                Categories: product.categories,
                ImageURL: product.featuredImage,
                URL: 'https://reef-admin.myshopify.com' + product.url,
                Brand: product.vendor,
                Price: product.formattedPrice,
                CompareAtPrice: product.formattedCompareAtPrice,
              };
              _learnq.push(['track', 'Viewed Out of Stock Product', itemTrack]);
              _learnq.push([
                'trackViewedItem',
                {
                  Title: itemTrack.Name,
                  ItemId: itemTrack.ProductID,
                  Categories: itemTrack.Categories,
                  ImageUrl: itemTrack.ImageURL,
                  Url: itemTrack.URL,
                  Metadata: {
                    Brand: itemTrack.Brand,
                    Price: itemTrack.Price,
                    CompareAtPrice: itemTrack.CompareAtPrice,
                  },
                },
              ]);
            }
            let otherSwatchSpan = document.createElement('span');
            otherSwatchSpan.textContent = value;
            otherSwatch.appendChild(otherSwatchSpan);
            if (!displayedOptions.includes(value)) {
              sizeListNode.appendChild(otherSwatch);
              otherSwatch.addEventListener('click', (e) => {
                if (e.currentTarget.classList.contains('selected')) {
                  return false;
                }
                let choosedVariant = product.variants.filter((variant) => {
                  return variant.options.includes(value);
                });
                if (product.size_guide_cta_enabled) {
                  if (
                    document.querySelector(
                      `.size-guide-table .add-size[data-variant-option-value="${choosedVariant[0].options[1]}"]`,
                    )
                  ) {
                    document
                      .querySelector(
                        `.size-guide-table .add-size[data-variant-option-value="${choosedVariant[0].options[1]}"]`,
                      )
                      .click();
                  } else {
                    const sizeCells = document.querySelectorAll(
                      '.size-guide-table td',
                    );
                    sizeCells.forEach((cell) => {
                      cell.classList.remove('selected');
                    });
                  }
                }
                if (history.replaceState && type == 'main-product') {
                  var newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${choosedVariant[0].id}`;
                  window.history.replaceState({ path: newurl }, '', newurl);
                }
                let selectedSwatchNode = sizeListNode.querySelector(
                  `.variants__size--item.selected`,
                );
                if (selectedSwatchNode) {
                  selectedSwatchNode.classList.remove('selected');
                }
                e.currentTarget.classList.add('selected');
                if (choosedVariant[0].available == false) {
                  let itemTrack = {
                    Name: product.title,
                    ProductID: choosedVariant[0].id,
                    Categories: product.categories,
                    ImageURL: product.featuredImage,
                    URL: 'https://reef-admin.myshopify.com' + product.url,
                    Brand: product.vendor,
                    Price: product.formattedPrice,
                    CompareAtPrice: product.formattedCompareAtPrice
                      ? product.formattedCompareAtPrice
                      : '$0.00',
                  };
                  if (!product.trackedVariants) {
                    product.trackedVariants = [];
                  }
                  if (typeof _learnq != 'undefined') {
                    if (
                      !product.trackedVariants.includes(choosedVariant[0].id)
                    ) {
                      product.trackedVariants.push(choosedVariant[0].id);
                      _learnq.push([
                        'track',
                        'Viewed Out of Stock Product',
                        itemTrack,
                      ]);
                      _learnq.push([
                        'trackViewedItem',
                        {
                          Title: itemTrack.Name,
                          ItemId: itemTrack.ProductID,
                          Categories: itemTrack.Categories,
                          ImageUrl: itemTrack.ImageURL,
                          Url: itemTrack.URL,
                          Metadata: {
                            Brand: itemTrack.Brand,
                            Price: itemTrack.Price,
                            CompareAtPrice: itemTrack.CompareAtPrice,
                          },
                        },
                      ]);
                    }
                  }
                  formWrapButtons.forEach((formWrapButton) => {
                    formWrapButton.classList.add('out-of-stock');
                    formWrapButton.textContent = 'Out of stock';
                    formWrapButton.removeAttribute('data-selected-variant');
                    formWrapButton.removeAttribute('data-drawer-trigger');
                    if (product.tags.includes('flag:enable-back-in-stock')) {
                      if (backInStockForm && backInStockFormButton) {
                        formWrapButton.classList.add('hide-add');
                        backInStockForm.forEach((form) => {
                          form.style.display = 'block';
                          backInStockFormButton.forEach((button) => {
                            setAttributes(button, {
                              'data-variant-productId':
                                choosedVariant[0].productId,
                              'data-bis-variant-id': choosedVariant[0].id,
                            });
                          });
                        });
                      }
                    }
                  });
                } else {
                  this.updatePrice(choosedVariant[0]);
                  this.updateCompareAtPrice(choosedVariant[0]);
                  this.updateKlarna(choosedVariant[0]);
                  formWrapButtons.forEach((formWrapButton) => {
                    formWrapButton.classList.remove('hide-add', 'out-of-stock');
                    if (formWrapButton && backInStockForm) {
                      backInStockForm.forEach((form) => {
                        form.style.display = 'none';
                      });
                    }
                    formWrapButton.textContent = 'Add to Cart';
                  });
                  let paymentVariantIdNode = this.el.querySelector(
                    '.payment_variant_id',
                  );
                  let paymentProductIdNode = this.el.querySelector(
                    '.payment_product_id',
                  );
                  if (paymentVariantIdNode && paymentProductIdNode) {
                    paymentVariantIdNode.value = choosedVariant[0].id;
                    paymentProductIdNode.value = choosedVariant[0].productId;
                  }
                  let comparePriceAttribute = choosedVariant[0].compareAtPrice
                    ? choosedVariant[0].compareAtPrice
                    : '';
                  if (
                    this.el &&
                    this.el.querySelector('.variants__size--label p span')
                  ) {
                    this.el.querySelector(
                      '.variants__size--label p span',
                    ).style.display = 'none';
                  }
                  formWrapButtons.forEach((formWrapButton) => {
                    setAttributes(formWrapButton, {
                      'data-selected-variant': choosedVariant[0].id,
                      'data-drawer-trigger': '',
                      'data-compare-price-item': comparePriceAttribute,
                      'data-price-item': choosedVariant[0].price,
                    });
                  });
                }
              });
              displayedOptions.push(value);
            }
          });
          if (displayedOptions.length > 1) {
            sizeContainerNode.style.display = 'block';
          }
        }
      }
    });
  };

  buildSrcSet = (image) => {
    let RangeWidths = [80, 160, 240];
    let dataSrcSet = '';
    for (var i = 0; i < RangeWidths.length; i++) {
      dataSrcSet += image + '_' + RangeWidths[i] + 'w';
      if (i < RangeWidths.length - 1) {
        dataSrcSet += ', ';
      }
    }
    return dataSrcSet;
  };

  initZoomCarousel = (el) => {
    if (el.querySelector('.swiper-wrapper') == null) {
      let html = el.innerHTML;
      let swiperHtml = `<div class='swiper-wrapper'>${html}</div>`;
      el.innerHTML = swiperHtml;
    }
    let slides = el.querySelectorAll(`.main-product__image--item`);
    slides.forEach((slide) => {
      if (!slide.parentNode.classList.contains('swiper-slide')) {
        let slideHtml = slide.outerHTML;
        let swiperSlideHtml = `<div class='swiper-slide'>${slideHtml}</div>`;
        slide.outerHTML = swiperSlideHtml;
      }
    });
    const swiper = new Swiper(el, {
      direction: 'vertical',
      mousewheelControl: true,
      slidesPerView: 'auto',
      freeMode: true,
      loop: true,
      spaceBetween: 20,
    });
    return swiper;
  };

  initZoom = (type) => {
    let zoomLinks = this.el.querySelectorAll(
      `.${type}__image .${type}__image--item [data-zoom-index]`,
    );

    zoomLinks.forEach((zoomLink) => {
      zoomLink.addEventListener('click', (e) => {
        e.preventDefault();
        if (this.initedZoomCarousel) {
          this.initedZoomCarousel.destroy();
        }
        this.initedZoomCarousel = this.initZoomCarousel(
          this.el.querySelector(`[data-zoom-main]`),
        );
        let initialZoom = e.currentTarget.dataset.zoomIndex;
        this.initedZoomCarousel.slideToLoop(initialZoom);
        let zoomWrap = this.el.querySelector(`[data-zoom-wrap]`);
        let thumbanailsZoom = this.el.querySelectorAll(
          `[data-zoom-thumbnails] [data-zoom-thumb]`,
        );
        if (thumbanailsZoom.length * 70 > window.innerHeight) {
          zoomWrap.classList.add('flex-start');
        }
        let mainZoom = this.el.querySelector(`[data-zoom-main]`);
        let initialZoomThumb = this.el.querySelector(
          `[data-zoom-thumbnails] [data-zoom-thumb][data-zoom-index="${initialZoom}"]`,
        );
        document.querySelector('html')?.classList?.add('disable-scroll');
        zoomWrap.style.display = 'flex';
        // mainZoom.scroll({
        //   top: initialZoomImage.offsetTop,
        //   behavior: 'smooth',
        // });
        initialZoomThumb.classList?.add('selected');
        window.addEventListener('keydown', (e) => {
          if (e.key == 'Escape') {
            document.querySelector('html')?.classList?.remove('disable-scroll');
            zoomWrap.style.display = 'none';
            mainZoom.scroll({
              top: 0,
              behavior: 'smooth',
            });
            let selectedThumb = this.el.querySelector(
              `[data-zoom-thumbnails] .selected[data-zoom-thumb]`,
            );
            if (selectedThumb) {
              selectedThumb.classList?.remove('selected');
            }
          }
        });
        thumbanailsZoom.forEach((thumbanail) => {
          thumbanail.addEventListener('click', (e) => {
            let zoomIndex = e.currentTarget.dataset.zoomIndex;
            let selectedThumb = this.el.querySelector(
              `[data-zoom-thumbnails] .selected[data-zoom-thumb]`,
            );
            // mainZoom.scroll({
            //   top: mainZoomItem.offsetTop,
            //   behavior: 'smooth',
            // });
            if (selectedThumb) {
              selectedThumb.classList?.remove('selected');
            }
            e.currentTarget.classList?.add('selected');
            this.initedZoomCarousel.slideToLoop(zoomIndex);
          });
        });
      });
    });

    this.el
      .querySelector(`[data-zoom-close]`)
      .addEventListener('click', (e) => {
        document.querySelector('html')?.classList?.remove('disable-scroll');
        this.el.querySelector(`[data-zoom-wrap]`).style.display = 'none';
        let selectedThumb = this.el.querySelector(
          `[data-zoom-thumbnails] .selected[data-zoom-thumb]`,
        );
        if (selectedThumb) {
          selectedThumb.classList?.remove('selected');
        }
      });
  };

  BISInit = (type) => {
    const mainBIS = document.querySelector(
      '.main-product__back-in-stock-form-email.main',
    );
    const secondBIS = document.querySelector(
      '.main-product__back-in-stock-form-email.sizeguide',
    );
    if (mainBIS == null) {
      return;
    }
    mainBIS.addEventListener('input', (e) => {
      if (secondBIS) {
        secondBIS.innerText = e.target.value;
        secondBIS.value = e.target.value;
      }
    });

    // on pages where a size guide isn't used, we need to skip this
    if (secondBIS) {
      secondBIS.addEventListener('input', (e) => {
        mainBIS.innerText = e.target.value;
        mainBIS.value = e.target.value;
      });
    }

    let formButton = this.el.querySelectorAll(
      `.${type}__back-in-stock-form-button`,
    );
    formButton.forEach((fButton) => {
      fButton.addEventListener('click', (e) => {
        const emails = this.el.querySelectorAll(
          `.${type}__back-in-stock-form-email`,
        );

        emails.forEach((email) => {
          let emailVal = email.value,
            productId = fButton.dataset.variantProductid,
            variantId = fButton.dataset.bisVariantId;
          if (validateEmail(emailVal)) {
            window.BIS.create(emailVal, variantId, productId, {
              accepts_marketing: true,
            });
            this.el
              .querySelectorAll(`.${type}__back-in-stock`)
              .forEach((bis) => {
                bis.classList.add('success');
              });
            this.el
              .querySelectorAll(`.${type}__back-in-stock-form-email`)
              .forEach((bis) => {
                bis.classList?.remove('invalid');
              });
            this.el
              .querySelectorAll(`.${type}__back-in-stock`)
              .forEach((bis) => {
                bis.classList.remove('error');
              });
          } else {
            this.el
              .querySelectorAll(`.${type}__back-in-stock-form-email`)
              .forEach((bis) => {
                bis.classList?.add('invalid');
              });
            this.el
              .querySelectorAll(`.${type}__back-in-stock`)
              .forEach((bis) => {
                bis.classList?.add('error');
              });
            this.el
              .querySelectorAll(`.${type}__back-in-stock`)
              .forEach((bis) => {
                bis.classList.remove('success');
              });
          }
        });
      });
    });
  };
}
